import { gql, useQuery } from '@apollo/client'
import planResult from './planQueryResult'
const useStudentDashboardPlansToSend = (vars = {}) => {
    return useQuery(
        gql`
        query {
            studentDashboardPlansToSend {
                ${planResult}
            }  
        }`,
        {
            variables: vars,
            fetchPolicy: 'cache-first'
        }
    )
}

export default useStudentDashboardPlansToSend